import CharScene from './char-scene.entity';
import ChangeScene from '../change-scenes/change-scene.entity';
import Change from '../changes/change.entity';
import Character from '../characters/character.entity';
import EpisodicActor from '../episodic-actors/episodic-actor.entity';
import EpisodicCharacter from '../episodic-characters/episodic-character.entity';
import HaChangeScene from '../ha-change-scenes/ha-change-scene.entity';
import HaChange from '../ha-changes/ha-change.entity';
import MuChangeScene from '../mu-change-scenes/mu-change-scene.entity';
import MuChange from '../mu-changes/mu-change.entity';
import PropSceneCharScene from '../prop-scene-char-scenes/prop-scene-char-scene.entity';
import PropScene from '../prop-scenes/prop-scene.entity';
import Scene from '../scenes/scene.entity';
import {
	SosCreateResponse,
	SosDeleteResponse,
	SosUpdateResponse,
} from '../sos-response';

export interface AddCharsToSceneResponse extends SosCreateResponse {
	created: {
		Character: Character[];
		CharScene: CharScene[];
	};
	updated: {
		EpisodicCharacter: EpisodicCharacter[];
		Scene: Scene[];
	};
}

export interface CreateEpCharForSceneResponse extends SosCreateResponse {
	created: {
		Character: Character[];
		CharScene: CharScene[];
		EpisodicActor: EpisodicActor[];
		EpisodicCharacter: EpisodicCharacter[];
	};
	updated: {
		Scene: Scene[];
	};
}

export interface DeleteCharSceneByEpCharIdAndSceneIdResponse
	extends SosDeleteResponse {
	destroyed: {
		CharScene: CharScene[];
		ChangeScene: ChangeScene[];
		HaChangeScene: HaChangeScene[];
		MuChangeScene: MuChangeScene[];
		PropScene: PropScene[];
		PropSceneCharScene: PropSceneCharScene[];
	};
	updated: {
		Change: Change[];
		EpisodicCharacter: EpisodicCharacter[];
		HaChange: HaChange[];
		MuChange: MuChange[];
		Scene: Scene[];
	};
}

export interface UpdateCharScenesResponse extends SosUpdateResponse {
	updated: {
		CharScene: CharScene[];
	};
}

export interface UpdatePropSceneCharScenesResponse
	extends SosCreateResponse,
		SosDeleteResponse {
	created: {
		PropSceneCharScene: PropSceneCharScene[];
	};
	destroyed: {
		PropSceneCharScene: PropSceneCharScene[];
	};
}
